import { render, staticRenderFns } from "./TableSport.vue?vue&type=template&id=6ae460fa&"
import script from "./TableSport.vue?vue&type=script&lang=js&"
export * from "./TableSport.vue?vue&type=script&lang=js&"
import style0 from "./TableSport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports